"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Calendar = void 0;

var _react = _interopRequireDefault(require("react"));

var _const = require("../../const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Calendar = function Calendar(props) {
  var color = _const.Colors[props.color] || _const.Colors.Primary;
  var size = _const.Size[props.size] || 24;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    style: {
      color: color
    },
    viewBox: '0 0 24 24' // fill={color}
    ,
    className: props.className,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3a1 1 0 012 0v1h6V3a1 1 0 112 0v1h2a3 3 0 013 3v12a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3h2V3zm8 3v1a1 1 0 102 0V6h2a1 1 0 011 1v3H4V7a1 1 0 011-1h2v1a1 1 0 002 0V6h6zM4 12v7a1 1 0 001 1h14a1 1 0 001-1v-7H4z",
    fill: "currentColor"
  }));
};

exports.Calendar = Calendar;
Calendar.displayName = 'Calendar';
var _default = Calendar;
exports["default"] = _default;